import { Theme } from '@mui/material/styles'

export default function Circular(_: Theme) {
  return {
    MuiCircularProgress: {},
  }
}
